import { render, staticRenderFns } from "./EditContactNameFormModal.vue?vue&type=template&id=a5101682"
import script from "./EditContactNameFormModal.vue?vue&type=script&lang=js"
export * from "./EditContactNameFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports